import { PROJECT_STATUS } from '@highlight-cp/project-api';
import type { Project } from '@highlight-cp/project-api';

const EDITABLE_PROJECT_STATUSES = [PROJECT_STATUS.NOT_STARTED, PROJECT_STATUS.DRAFTING] as const;

/**
 * Returns whether a project status allows editing setup (audience, surveys, products, etc.).
 * Missing or unknown status is treated as not editable.
 */
export const isProjectEditable = (project?: Pick<Project, 'status'> | null): boolean => {
  const projectStatus = project?.status;

  if (!projectStatus) {
    return false;
  }

  return EDITABLE_PROJECT_STATUSES.includes(
    projectStatus as (typeof EDITABLE_PROJECT_STATUSES)[number],
  );
};
